import React from 'react'
import Group from 'components/utils/Group'
import LesaPurchaseSummaryContainer from './LesaPurchaseSummaryContainer'
import LesaPurchaseSummaryHeader from './LesaPurchaseSummaryHeader'
import LoadingBox from 'components/Common/Loading/LoadingBox'

interface Props {
  hideSelect?: boolean;
}

function LesaPurchaseSummarySkeleton({ hideSelect }: Props) {
  return (
    <LesaPurchaseSummaryContainer>
      <LesaPurchaseSummaryHeader>
        <LoadingBox style={{ width: 160, height: 16 }} />
        {!hideSelect && <LoadingBox style={{ width: 60, height: 24 }} />}
      </LesaPurchaseSummaryHeader>
      <Group direction="vertical" tabletDirection="horizontal" horizontalAlign="space-between" verticalAlign="end" gap={16}>
        <Group direction="vertical" gap={4}>
          <LoadingBox style={{ width: 100, height: 14 }} />
          <LoadingBox style={{ width: '100%', height: 20 }} />
          <LoadingBox style={{ width: '90%', height: 20 }} />
          <LoadingBox style={{ width: 140, height: 16 }} />
          <LoadingBox style={{ width: 120, height: 16 }} />
        </Group>
        {!hideSelect && <LoadingBox style={{ width: 80, height: 32 }} />}
      </Group>
    </LesaPurchaseSummaryContainer>
  )
}

export default LesaPurchaseSummarySkeleton
